import React, { createContext, useContext, useState } from 'react';
import { ProposalInput } from 'generated/graphql';
import { ISimulationResult } from 'interfaces/interfaces';

interface AcceptedProposalVariables {
    loanApplicationId: string;
    proposal: ProposalInput;
    insuranceAccepted: boolean;
    simulation: ISimulationResult;
    form: ProposalInput;
}

interface AcceptedProposalContextProps {
    acceptedProposal: AcceptedProposalVariables | null;
    setAcceptedProposal: (data: AcceptedProposalVariables) => void;
}

const AcceptedProposalContext = createContext<AcceptedProposalContextProps | undefined>(undefined);

export const AcceptedProposalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [acceptedProposal, setAcceptedProposalState] = useState<AcceptedProposalVariables | null>(null);

    const setAcceptedProposal = (data: AcceptedProposalVariables) => {
        setAcceptedProposalState(data);
    };

    return (
        <AcceptedProposalContext.Provider
            value={{
                acceptedProposal,
                setAcceptedProposal,
            }}
        >
            {children}
        </AcceptedProposalContext.Provider>
    );
};

export const useAcceptedProposal = (): AcceptedProposalContextProps => {
    const context = useContext(AcceptedProposalContext);

    return context;
};